import { useQuery } from '@apollo/client'
import { GET_CUSTOMER_DISPLAY_MY_CIRCLE } from '../graphql'

export interface CustomerDisplayMyCircleInput {
  customerUuid: string
}

export interface CustomerDisplayMyCircleData {
  ybGetCustomerDisplayMyCircle: {
    customerUuid: string
    displayMyCircle: boolean
  }
}

export interface CustomerDisplayMyCircleVars {
  input: CustomerDisplayMyCircleInput
}

const useCustomerDisplayMyCircle = (input: CustomerDisplayMyCircleInput) =>
  useQuery<CustomerDisplayMyCircleData, CustomerDisplayMyCircleVars>(
    GET_CUSTOMER_DISPLAY_MY_CIRCLE,
    {
      variables: { input },
      errorPolicy: 'all',
      skip: !input.customerUuid,
    }
  )

export default useCustomerDisplayMyCircle
